import React from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/Baskan.css';
import Header from '../components/Header';
import TabBar from '../components/TabBar';

const Baskan: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="baskan-container">
      <Header title="Başkanımız" />
      <div className="baskan-content" style={{ paddingTop: '80px' }}>
        <div className="baskan-header">
          <h1>Başkanımız</h1>
        </div>
        
        <div className="baskan-info">
          <img 
            src="/images/baskan.jpg" 
            alt="Fahrettin Can" 
            className="baskan-image"
          />
          <h2>Fahrettin CAN</h2>
          <p className="baskan-title">İstanbul Havalimanı Taksi Kooperatifi Başkanı</p>
          
          <div className="baskan-message">
            <p>
              Değerli üyelerimiz ve misafirlerimiz,
            </p>
            <p>
              İstanbul Havalimanı Taksi Kooperatifi olarak, sizlere en kaliteli ve güvenli ulaşım hizmetini sunmak için çalışıyoruz. 
              Modern filomuz ve profesyonel şoför kadromuzla, İstanbul'un yeni gururu olan havalimanımızda 7/24 hizmetinizdeyiz.
            </p>
            <p>
              Misyonumuz, yolcularımıza konforlu, güvenli ve zamanında ulaşım hizmeti sağlamak, vizyonumuz ise sektörde öncü ve örnek bir kuruluş olmaktır.
            </p>
            <p>
              Sizlerin memnuniyeti ve güveni, bizim en büyük motivasyon kaynağımızdır.
            </p>
            <p className="baskan-signature">
              Saygılarımla,<br />
              Fahrettin CAN<br />
              Yönetim Kurulu Başkanı
            </p>
          </div>
        </div>
      </div>
      <TabBar />
    </div>
  );
};

export default Baskan; 